import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {useTranslation} from '@malt/vue3-use';
    import ApplicationStatus from '@/profile-creation-wizard/components/waiting-room/ApplicationStatus.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Error',
  setup(__props) {

    const {msg} = useTranslation();
    const statusData = {
        title: msg('profile.creation.wizard.strategy.waiting.room.error.title'),
        imageUrl: 'https://dam.malt.com/signup/waiting-room/error.png?vh=d6268c',
        faqLink: msg('profile.creation.wizard.strategy.waiting.room.error.faq'),
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ApplicationStatus, _normalizeProps(_guardReactiveProps(statusData)), {
    content: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.waiting.room.error.line1')), 1)
    ]),
    _: 1
  }, 16))
}
}

})